@if (control()) {
  <textarea
    [formControl]="formControl"
    [placeholder]="placeholder()"
    [readOnly]="readOnly()"
    [ngClass]="{
      'bg-transparent': !global(),
      'form-control-lg form-control-solid': global(),
      'is-invalid':
        !skipValidation() && control()!['touched'] && control()?.invalid,
      'is-valid': !skipValidation() && control()?.valid && formControl.value,
    }"
    coreNoLeadingSpace
    class="form-control textarea"
  ></textarea>
}
@if (!control()) {
  <textarea
    [value]="value()"
    [readOnly]="readOnly()"
    [placeholder]="placeholder()"
    [ngClass]="{
      'bg-transparent': !global(),
      'form-control-lg form-control-solid': global(),
    }"
    coreNoLeadingSpace
    class="form-control textarea"
  ></textarea>
}
@if (control() && control()!['touched']) {
  <ui-validation-form [control]="control()!"></ui-validation-form>
}
@if (description()) {
  <div class="form-text">{{ description() }}</div>
}
